import { render, staticRenderFns } from "./EmbeddedUserForm.vue?vue&type=template&id=6aa6c456&scoped=true"
import script from "./EmbeddedUserForm.vue?vue&type=script&lang=js"
export * from "./EmbeddedUserForm.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedUserForm.vue?vue&type=style&index=0&id=6aa6c456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa6c456",
  null
  
)

export default component.exports